import React from 'react';

type TagsProps = {
    tags: string[]
}

function Tags(props: TagsProps) {
    return (
        <ul className={"molekules-two-tags"}>
            {
                props.tags.map(tag => <li key={tag} className={"tag"}>{tag}</li>)
            }
        </ul>
    );
}

export default Tags;
